import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromApps from './events-db.reducer';

const selectEventsDB = createFeatureSelector<fromApps.TEventsDatabase>('eventsDB');

export const getAllEvents = createSelector(selectEventsDB, (eventsDB) => {
  if (eventsDB && eventsDB.entities['EVENTS']) {
    return Object.values(eventsDB.entities['EVENTS']);
  }
  return [];
});
